import { type TipoIdentificacion, type Genero, type Grupo, type ParametricData, type UnidadMedida, type Procedencia, type OrigenProducto, type Empaque, type Duenio, type Encargado  } from '../types/catalog';
import { http } from '../api/http';

export class CatalogService {
  private static readonly ENDPOINTS = {
    TIPOS_IDENTIFICACION: '/catalog/tipos-identificacion',
    GENEROS: '/catalog/generos',
    GRUPOS: '/catalog/grupos',
    UNIDADES_MEDIDA: '/catalog/unidades-medida',
    PROCEDENCIAS: '/Catalog/procedencias',
    ORIGEN_PRODUCTOS: '/Catalog/origen-productos',
    EMPAQUES: '/Catalog/empaques',
    DUENIOS: '/Catalog/duenios',
    ENCARGADOS: '/Catalog/encargados',
  };

  private static async fetchWithAuth<T>(endpoint: string): Promise<T> {
    const response = await http.get(endpoint);
    return response.data;
  }

  public static async getTiposIdentificacion(): Promise<TipoIdentificacion[]> {
    try {
      return await this.fetchWithAuth<TipoIdentificacion[]>(this.ENDPOINTS.TIPOS_IDENTIFICACION);
    } catch (error) {
      console.error('Error fetching tipos identificacion:', error);
      throw error;
    }
  }

  public static async getGeneros(): Promise<Genero[]> {
    try {
      return await this.fetchWithAuth<Genero[]>(this.ENDPOINTS.GENEROS);
    } catch (error) {
      console.error('Error fetching generos:', error);
      throw error;
    }
  }

  public static async getGrupos(): Promise<Grupo[]> {
    try {
      return await this.fetchWithAuth<Grupo[]>(this.ENDPOINTS.GRUPOS);
    } catch (error) {
      console.error('Error fetching grupos:', error);
      throw error;
    }
  }

  public static async getUnidadesMedida(): Promise<UnidadMedida[]> {
    try {
      return await this.fetchWithAuth<UnidadMedida[]>(this.ENDPOINTS.UNIDADES_MEDIDA);
    } catch (error) {
      console.error('Error fetching unidades medida:', error);
      throw error;
    }
  }

  public static async getAllParametricData(): Promise<ParametricData> {
    try {
      const [tiposIdentificacion, generos, grupos] = await Promise.all([
        this.getTiposIdentificacion(),
        this.getGeneros(),
        this.getGrupos(),
      ]);

      return {
        tiposIdentificacion,
        generos,
        grupos,
      };
    } catch (error) {
      console.error('Error fetching parametric data:', error);
      throw error;
    }
  }

  public static async getProcedencias(): Promise<Procedencia[]> {
    try {
      return await this.fetchWithAuth<Procedencia[]>(this.ENDPOINTS.PROCEDENCIAS);
    } catch (error) {
      console.error('Error fetching procedencias:', error);
      throw error;
    }
  }

  public static async getOrigenProductos(): Promise<OrigenProducto[]> {
    try {
      return await this.fetchWithAuth<OrigenProducto[]>(this.ENDPOINTS.ORIGEN_PRODUCTOS);
    } catch (error) {
      console.error('Error fetching origen productos:', error);
      throw error;
    }
  }
  public static async getEmpaques(): Promise<Empaque[]> {
    try {
      return await this.fetchWithAuth<Empaque[]>(this.ENDPOINTS.EMPAQUES);
    } catch (error) {
      console.error('Error fetching empaques:', error);
      throw error;
    }
  }

  public static async getDuenios(): Promise<Duenio[]> {
    try {
      return await this.fetchWithAuth<Duenio[]>(this.ENDPOINTS.DUENIOS);
    } catch (error) {
      console.error('Error fetching duenios:', error);
      throw error;
    }
  }

  public static async getEncargados(): Promise<Encargado[]> {
    try {
      return await this.fetchWithAuth<Encargado[]>(this.ENDPOINTS.ENCARGADOS);
    } catch (error) {
      console.error('Error fetching encargados:', error);
      throw error;
    }
  }
}